import { render, staticRenderFns } from "./email-link.vue?vue&type=template&id=3bb89b5a&"
import script from "./email-link.vue?vue&type=script&lang=js&"
export * from "./email-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports